export { EntSignatureDisplayType } from '../../impl/logical/mail/mail_action_store_model';
